module.exports = __webpack_public_path__ + "static/media/Sales_pilot_logo_animation_1.0.f560cc7a.mp4";